var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0352 13.9746L16.5273 10.7402H13.3984V8.63086C13.3984 7.7168 13.8203 6.87305 15.2266 6.87305H16.668V4.0957C16.668 4.0957 15.3672 3.84961 14.1367 3.84961C11.5703 3.84961 9.88281 5.43164 9.88281 8.24414V10.7402H7V13.9746H9.88281V21.8496H13.3984V13.9746H16.0352Z",
    fill: "#111827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.b6becfdc32675908307f2c49314015e8.svg";
export { ForwardRef as ReactComponent };